module.exports = __webpack_public_path__ + "static/img/cont2401.0250ac3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2401.jpg
// module id = ITM9
// module chunks = 0